/**
 * Get a relative date string: today/tomorrow labels, otherwise a short
 * locale-formatted date (e.g. "10 gen").
 */
export function getRelativeDate(date: Date, locale: string, todayLabel: string, tomorrowLabel: string): string {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const matchDate = new Date(date);
    matchDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    tomorrow.setHours(0, 0, 0, 0);

    if (matchDate.getTime() === today.getTime()) {
        return todayLabel;
    }
    if (matchDate.getTime() === tomorrow.getTime()) {
        return tomorrowLabel;
    }
    return date.toLocaleDateString(locale, {
        day: "numeric",
        month: "short",
    });
}
